import {get} from "../../../utils/services/Request";

export const getPartPrice = (storePartNumber: string): Promise<any> => get(`/store_part_conf/${storePartNumber}/price`)
